import { z } from 'zod';
import { NOTIFICATION_TYPE } from '../constnats/notification';

export const notificationInfoSchema = z.object({
    id: z.number().int(),
    type: z.string(),
    title: z.string(),
    message: z.string(),
    referenceType: z.string().nullable(),
    referenceId: z.number().int().nullable(),
    isRead: z.boolean(),
    createdAt: z.string(),
});

export type NotificationInfoType = z.infer<typeof notificationInfoSchema>;
